import { render } from "./USDC.vue?vue&type=template&id=b7182dc4"
import script from "./USDC.vue?vue&type=script&lang=js"
export * from "./USDC.vue?vue&type=script&lang=js"
script.render = render

export default script